import React, { useEffect, useRef, useState } from 'react';
import './About.css';

function About() {
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const paragraphRefs = useRef([]);

  useEffect(() => {
    paragraphRefs.current = paragraphRefs.current.slice(0, 3);
    
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div 
      ref={sectionRef} 
      className={`about-page ${isVisible ? 'active' : ''}`}
    >
      <h1>About <span>.</span></h1>

      <div className="about-page-para">
        <p 
          ref={el => paragraphRefs.current[0] = el}
          className={isVisible ? 'visible' : ''}
          style={{ animationDelay: '0.3s' }}
        >
          I am a self-taught web developer with three years of experience specializing in Node.js to build efficient, scalable applications for diverse business needs.
        </p>

        <p 
          ref={el => paragraphRefs.current[1] = el}
          className={isVisible ? 'visible' : ''}
          style={{ animationDelay: '0.6s' }}
        >
          Focused on creating user-centric solutions, I combine technical expertise with a keen understanding of industry challenges to deliver impactful, streamlined applications.
        </p>

        <p 
          ref={el => paragraphRefs.current[2] = el}
          className={isVisible ? 'visible' : ''}
          style={{ animationDelay: '0.9s' }}
        >
          Continuously advancing my skills, I am committed to providing innovative, high-quality web solutions that drive business growth.
        </p>
      </div>
      
      <div className={`skills-highlight ${isVisible ? 'visible' : ''}`}>
        <div className="skill-tag">Node.js</div>
        <div className="skill-tag">React</div>
        <div className="skill-tag">MongoDB</div>
        <div className="skill-tag">Express</div>
        <div className="skill-tag">User Experience</div>
      </div>
    </div>
  );
}

export default About;